<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText: '新增活动', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '分类标题',
              prop: 'title',
              span: 24,
              rules: [{
                type: 'string', required: true, message: '调查标题不能为空', trigger: 'blur'
              }]
            },
            {
              label: '排序',
              prop: 'sort_id',
              type: 'number',
              value: 100,
              tip: '排序ID越小越靠前',
              span: 24
            }
          ]
        }
      }
    }
  }
</script>
